
import styles from "../../AccountingPage.module.scss";
import { useEffect, useState } from 'react'
import Notification from "utils/Notifications";
import React, { useRef } from "react";


import { getStudentsFilterData, postStudentsReleaseData, getAcademicYearsData, getBranchesData, getEducationTypesData, getDepartmentsData, getSpecialitiesData, getCoursesData } from "service/AccountingService";


const StudentsContent = ({ render, setRender, id }) => {
    const componentRef = useRef();

    const [academicyears, setAcademicYears] = useState([]);
    const getAcademicYears = async (id) => {
        try {
            let response = await getAcademicYearsData(id, academicyears);
            setAcademicYears(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };
    const [branches, setBranches] = useState([]);
    const getBranches = async (id) => {
        try {
            let response = await getBranchesData(id, branches);
            setBranches(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    const [educationtypes, setEducationTypes] = useState([]);
    const getEducationTypes = async (id) => {
        try {
            let response = await getEducationTypesData(id, educationtypes);
            setEducationTypes(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    const [departments, setDepartments] = useState([]);
    const getDepartments = async (id) => {
        try {
            let response = await getDepartmentsData(id, departments);
            setDepartments(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    const [specialities, setSpecialities] = useState([]);
    const getSpecialities = async (id) => {
        try {
            let response = await getSpecialitiesData(id, departments);
            setSpecialities(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    const [courses, setCourses] = useState([]);
    const getCourses = async (id) => {
        try {
            let response = await getCoursesData(id, courses);
            setCourses(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };


    const [academicYearID, setAcademicYearID] = useState("");
    const [branchID, setBranchID] = useState("");
    const [departmentID, setDepartmentID] = useState("");
    const [educationTypeID, setEducationTypeID] = useState("");
    const [courseID, setCourseID] = useState("");
    const [specialitieID, setSpecialitieID] = useState("");

    const handleSelectAcademicYear = (id) => {
        setAcademicYearID(id);
    };
    const handleSelectBranch = (id) => {
        setBranchID(id);
        getDepartments(id)
        setDepartmentID("")
    };
    const handleSelectDepartment = (id) => {
        setDepartmentID(id);
        getSpecialities(id)
        setSpecialitieID("")
    };
    const handleSelectEducationType = (id) => {
        setEducationTypeID(id);
    };
    const handleSelectCourse = (id) => {
        setCourseID(id);
    };
    const handleSelectSpecialitie = (id) => {
        setSpecialitieID(id);
    };
    const [data, setData] = useState([]);
    const getData = async (specialitieid, academicyearid, educationtypeid, courseid) => {
        try {
            let response = await getStudentsFilterData(specialitieid, academicyearid, educationtypeid, courseid);
            setData(response.data);

        } catch (error) {
            console.log("onoxo")
        }
    };

    useEffect(() => {
        if (academicYearID && specialitieID && educationTypeID && courseID) {
            getData(specialitieID, academicYearID, educationTypeID, courseID);
        }
    }, [academicYearID, specialitieID, educationTypeID, courseID]);

    useEffect(() => {

        getAcademicYears(id);
        getBranches(id);
        getCourses(id);
        getEducationTypes(id);
        setRender(false);

        // getData(id);


    }, [render]);


    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });


    const [selectedIds, setSelectedIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const handleSelectOne = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedIds([]);
        } else {
            const allIds = data.map((item) => item.id);
            setSelectedIds(allIds);
        }
        setSelectAll(!selectAll);
    };

    const [order, setOrder] = useState("");
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!order) {
            setNotify({
                isOpen: true,
                message: "Введите Приказ для выпуска!",
                type: "error",
            });
            return;
        }

        if (!selectedIds || selectedIds.length === 0) {
            setNotify({
                isOpen: true,
                message: "Выберите хотя бы одного студента!",
                type: "error",
            });
            return;
        }
        else {
            const formData = new FormData();
            formData.append('order', order);
            const rowsData = [];
            for (let i = 0; i < selectedIds.length; i++) {
                rowsData.push({
                    id: selectedIds[i],
                });
            }


            formData.append('row_id', JSON.stringify(rowsData));

            let data = await postStudentsReleaseData(formData);
            getData(specialitieID, academicYearID, educationTypeID, courseID);
            setNotify({
                isOpen: true,
                message: "Студенты успешно выпущены!",
                type: "success",
                sound: "success"
            });
            setRender(true);
        }
    };





    return (
        <>


            <div className={styles.div_search}>
                <h2 className={styles.project__h}>ВЫПУСК / Выберите данные</h2>
                <div className={styles.div_check_search_two}>
                    <div>
                        <select
                            value={academicYearID}
                            onChange={(e) => handleSelectAcademicYear(e.target.value)}
                        >
                            <option value="">Учебный год</option>
                            {Array.isArray(academicyears) && academicyears.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <select
                            value={educationTypeID}
                            onChange={(e) => handleSelectEducationType(e.target.value)}
                        >
                            <option value="">Вид обучения</option>
                            {Array.isArray(educationtypes) && educationtypes.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <select
                            value={branchID}
                            onChange={(e) => handleSelectBranch(e.target.value)}
                        >
                            <option value="">Филиал</option>
                            {Array.isArray(branches) && branches.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <select
                            value={departmentID}
                            onChange={(e) => handleSelectDepartment(e.target.value)}
                        >
                            <option value="">Подразделение</option>
                            {Array.isArray(departments) && departments.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>


                    <div>
                        <select
                            value={specialitieID}
                            onChange={(e) => handleSelectSpecialitie(e.target.value)}
                        >
                            <option value="">Специальности</option>
                            {Array.isArray(specialities) && specialities.map((item) => (
                                <option key={item.id} value={item.id}>{item.name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <select
                            value={courseID}
                            onChange={(e) => handleSelectCourse(e.target.value)}
                        >
                            <option value="">Курс</option>
                            {Array.isArray(courses) && courses.map((item) => (
                                <option key={item.id} value={item.id}>{item.name}</option>
                            ))}
                        </select>
                    </div>

                </div>
                <div style={{ marginTop: "30px" }}>

                    <input
                        type="text"
                        placeholder="Введите приказ на выпуск"
                        value={order}
                        onChange={(e) => setOrder(e.target.value)}
                        style={{ width: "30%" }}
                    />
                    <button
                        onClick={handleSubmit}
                        className={styles.open_btn_sub_two}
                        style={{
                            background: "#008000",
                            color: "#fff", marginBottom: "0"
                        }}
                    >
                        Выпуск


                    </button>
                </div>
            </div>




            <table ref={componentRef} className={styles.table__wrapper}>
                <thead className={styles.table__head}>
                    <tr className={styles.table__row}>
                        <th className={styles.table__item_student}>
                            <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                            />
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>Учебный год</span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>Вид обучения </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>ИНН</span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>Фамилия </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>Имя </span>
                        </th>

                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>Специальность </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>Курс </span>
                        </th>
                        <th className={styles.table__item_student}>
                            <span className={styles.table__title}>Статус </span>
                        </th>

                    </tr>
                </thead>

                <tbody className={styles.table__body}>
                    {data.map((item, index) => (

                        <tr className={styles.table__row} key={item.id}>
                            <td className={styles.table__item_student}>
                                <input
                                    type="checkbox"
                                    checked={selectedIds.includes(item.id)}
                                    onChange={() => handleSelectOne(item.id)}
                                />
                            </td>
                            <td className={styles.table__item_student}>
                                <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                    {item.academic_year_name}
                                </span>
                            </td>
                            <td className={styles.table__item_student}>
                                <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                    {item.educationtype_name}
                                </span>
                            </td>
                            <td className={styles.table__item_student}>
                                <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                    {item.inn}
                                </span>
                            </td>
                            <td className={styles.table__item_student}>
                                <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                    {item.surname}
                                </span>
                            </td>
                            <td className={styles.table__item_student}>
                                <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                    {item.first_name}
                                </span>
                            </td>


                            <td className={styles.table__item_student}>
                                <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                    {item.speciality_name}
                                </span>
                            </td>
                            <td className={styles.table__item_student}>
                                <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                    {item.course_name}
                                </span>
                            </td>

                            <td className={styles.table__item_student}>
                                <span
                                    className={styles.table__title}
                                    style={{
                                        fontWeight: '700',
                                        padding: '5px',
                                        borderRadius: '6px',
                                        display: "block",
                                        textAlign: "center",
                                        background:
                                            item.status === 'Зачислен(а)' ? '#5C5CFF' :
                                                item.status === 'Отчислен(а)' ? '#a00000ff' :
                                                    item.status === 'В академическом отпуске' ? '#ec9900ff' :
                                                        item.status === 'Переведен(а)' ? '#333333' :
                                                            item.status === 'Выпущен(а)' ? '#008000' :
                                                                'transparent',
                                        color: item.status ? 'white' : 'inherit',
                                    }}
                                >
                                    {item.status || ''}
                                </span>
                            </td>


                        </tr>
                    ))}

                    {/* Итого */}

                </tbody>




            </table>

            <Notification notify={notify} setNotify={setNotify} />
        </>


    );
};

export default StudentsContent;
